import React, { useState, useEffect } from 'react';
import { Accordion, Card } from 'react-bootstrap';
import EmployerPanel from '../Employer';
import {
  AccordionBlueUpArrow,
  TrashIcon,
  TrashIconDisable,
} from '../../../../img/findcare/FindCareSVG';
import EmployerViewListItem from '../Employer/EmployerViewListItem';
import GenericButton from 'src/Components/GenericButton/GenericButton';
import ShowMoreLess from 'src/Admin/components/common/ListWithShowMoreLess';

const BlobViewListItem = ({
  blob,
  onClick,
  accordionArrowClass,
  allowEmployerSelection,
  employerProps,
  onDeleteClick,
  locationProps,
  allowLocationSelection,
  showBlobDelete,
  showEmployerDelete,
  showLocationDelete,
  showMoreLocations,
  setShowMoreLocations,
  showMoreEmployers,
  setShowMoreEmployers,
  selectedEmployerData,
  selectedLocationData,
  onUnSelectedEmpHandler,
  editAffiliatedRecords,
}) => {
  function RenderEmployerListItem({ data }) {
    //console.log( 'Inside Render Employer List Item', data );
    const client = data;
    return (
      <EmployerViewListItem
        client={client}
        locationProps={{
          ...locationProps,
          locationCount: locationProps.selectedLocationCount(client.oid),
          selectedLocation: locationProps.selectedLocation[client.oid] || [],
        }}
        allowLocationSelection={allowLocationSelection}
        showDelete={showEmployerDelete}
        showLocationDelete={showLocationDelete}
        onDeleteClick={(e) =>
          employerProps.onEmpTrashButtonClickHandler(
            e,
            blob.oid,
            client.oid,
            client,
          )
        }
        showMoreLocations={showMoreLocations}
        setShowMoreLocations={setShowMoreLocations}
        selectedLocationData={selectedLocationData}
        selectedEmployerData={selectedEmployerData}
        editAffiliatedRecords={editAffiliatedRecords}
      />
    );
  }

  return (
    <div className="blob-accordion-container">
      <Accordion.Toggle
        as={Card.Header}
        className="panel-toggle text-left w-100"
        variant="link"
        eventKey={blob.BlkOfBusId}
        onClick={onClick}
      >
        <div className="d-flex panel-card-header">
          <div>
            <span className="arrow">
              <AccordionBlueUpArrow
                svgClassName={accordionArrowClass}
                className="acc-arrow"
              />
            </span>
            <span className="blob-name">{blob.BlkOfBusName}</span>{' '}
            <span className="blob-note">({employerProps.employerCount})</span>
          </div>
          {(allowEmployerSelection || showBlobDelete) && (
            <div>
              {allowEmployerSelection && (
                <EmployerPanel
                  onSelectedEmpHandler={employerProps.onSelectedEmployerHandler}
                  blobOid={blob.oid}
                  employerAllData={employerProps.employerAllData}
                  setEmployerAllData={employerProps.setEmployerAllData}
                  selectedEmployerData={employerProps.selectedEmployer}
                  onUnSelectedEmpHandler={onUnSelectedEmpHandler}
                  editAffiliatedRecords={editAffiliatedRecords}
                />
              )}
              {showBlobDelete ? (
                editAffiliatedRecords ? (
                  <button
                    type="button"
                    className="trash-button"
                    onClick={onDeleteClick}
                  >
                    <TrashIcon />
                  </button>
                ) : (
                  <button type="button" className="trash-button">
                    <TrashIconDisable />
                  </button>
                )
              ) : null}
            </div>
          )}
        </div>
      </Accordion.Toggle>
      <Accordion.Collapse eventKey={blob.BlkOfBusId}>
        <Card.Body>
          <ShowMoreLess
            data={employerProps.selectedEmployer || []}
            RenderItemComponent={RenderEmployerListItem}
            showMoreLabel={'Employers'}
            showMore={showMoreEmployers}
            setShowMore={setShowMoreEmployers}
          />
        </Card.Body>
      </Accordion.Collapse>
    </div>
  );
};

export default React.memo(BlobViewListItem);
